<template>
  <div>
    <img v-if="pc" :src="$t('projects.img')" width="100%" />
    <img v-else :src="$t('projects.imgm')" width="100%" />
    <div class="mw1200" :class="{mlr: !pc}" style="margin: 60px auto">
      <div class="h1_p">
        <h1 :class="{f36: !pc}">{{$t('projects.h1')}}</h1>
        <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'26px'}" v-html="pc? $t('projects.p') : $t('projects.p').replace(/&lt;br>/, '')"></p>
      </div>
      <div v-if="pc" style="display: flex;justify-content: space-between">
        <div style="width: 57%">
          <div v-for="i in 2" :key="i" :class="{pj_border: i === 1 ? current !== $t('projects.list').length - 1 : false}"
               style="margin-bottom: 50px;padding-bottom: 20px"
          >
            <template v-if="(current + i - 1) < $t('projects.list').length">
              <img :src="$t('projects.list')[current + i - 1].img" width="80%" style="margin-bottom: 30px"/>
              <div style="font-size: 20px;color: #7F1F20"
                   v-if="$t('projects.list')[current + i - 1].title"
                   v-html="$t('projects.list')[current + i - 1].title.replace(/&lt;br>/, '')"></div>
              <div style="font-size: 15px;" v-html="$t('projects.list')[current + i - 1].date"></div>
              <div style="font-size: 15px;line-height: 23px;margin-top: 10px" v-html="$t('projects.list')[current + i - 1].p"></div>
            </template>
          </div>
        </div>
        <div style="width: 35%;padding-left: 30px;border-left: 1px #00023d solid;height: fit-content">
          <div style="color: #7F1F20;font-size: 20px;margin-bottom: 15px">
            {{isEn?'Activities':'企业动态'}}
            <a-pagination v-model="page" :total="$t('home.projects').length" :pageSize="8" size="small" style="float:right;margin-top: 6px" />
          </div>
          <template v-for="i in 8">
            <template v-if="(8 * (page - 1) + i - 1) < $t('home.projects').length">
              <div :key="i" style="display: flex;position: relative;margin-bottom: 20px;justify-content: space-between">
                <div v-if="$t('home.projects')[8 * (page - 1) + i - 1].name"
                     v-text="$t('home.projects')[8 * (page - 1) + i - 1].name.replace(/&lt;br>/, '')"
                     style="width: 55%;line-height: 22px;font-size: 15px"
                ></div>
                <svg :class="[(8 * (page - 1) + i - 1) === current ? 'active' : '' ]" style="position: absolute;bottom: 0;left: 0;cursor: pointer" @click="c(8 * (page - 1) + i - 1)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56px" height="17px">
                  <path fill-rule="evenodd"  fill="rgb(179, 179, 179)" d="M0.924,7.006 L41.471,7.006 C39.517,4.244 38.545,2.443 38.445,-0.011 C42.711,2.539 47.996,4.410 55.647,8.497 C49.935,11.523 44.281,13.908 38.445,17.009 C38.745,14.341 39.555,12.730 41.532,9.793 L0.924,9.793 L0.924,7.006 Z"/>
                </svg>
                <img :src="$t('home.projects')[8 * (page - 1) + i - 1].img" width="40%" height="100" alt="projects" />
              </div>
            </template>
          </template>
          <a-pagination v-model="page" :total="$t('home.projects').length" :pageSize="8" size="small" style="padding-top: 10px;border-top: 1px #bfbfbf solid" />
        </div>
      </div>
      <div v-else>
        <template v-for="i in 2">
          <div :key="i" v-if="(2 * (page - 1) + i - 1) < $t('projects.list').length" style="margin-bottom: 50px;padding-bottom: 20px">
            <img :src="$t('projects.list')[2 * (page - 1) + i - 1].img" width="80%" style="margin-bottom: 30px"/>
            <div style="font-size: 26px;color: #7F1F20;line-height: 30px;margin-bottom: 5px"
                 v-if="$t('projects.list')[2 * (page - 1) + i - 1].title"
                 v-html="$t('projects.list')[2 * (page - 1) + i - 1].title.replace(/&lt;br>/, '')"></div>
            <div style="font-size: 20px;line-height: 24px" v-html="$t('projects.list')[2 * (page - 1) + i - 1].date"></div>
            <div style="font-size: 20px;line-height: 30px;margin-top: 10px" v-html="$t('projects.list')[2 * (page - 1) + i - 1].p"></div>
          </div>
        </template>
        <a-pagination v-model="page" :total="$t('home.projects').length" :pageSize="2" size="small" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Projects',
  data () {
    return {
      current: 0,
      page: 1
    }
  },
  computed: {
    ...mapGetters(['pc', 'isEn'])
  },
  methods: {
    c (id) {
      this.current = id
    }
  },
  mounted () {
    if (this.$route.params.id >= 0 && this.$route.params.id < this.$t('projects.list').length) {
      this.current = this.$route.params.id
      if (this.pc) {
        this.page = Math.ceil((this.current + 1) / 8)
      } else {
        this.page = Math.ceil((this.current + 1) / 2)
      }
    }
  }
}
</script>

<style lang="less">
  .pj_border {
    border-bottom: 1px #bfbfbf solid
  }
</style>
